import forage from 'localforage'

export const fTable = forage.createInstance({
  name: 'crms-table',
  storeName: 'rsm',
  driver: [
    forage.INDEXEDDB,
    forage.LOCALSTORAGE
  ]
})

const storageKey = 'officer-r-other-events'

const setTableOptions = ({ currentPage, perPage, sortBy, sortDesc, filter, totalRows }) => {
  return fTable.setItem(storageKey, {
    currentPage,
    perPage,
    sortBy,
    sortDesc,
    totalRows,
    filter: {
      province: '',
      municipality: '',
      status: 'All',
      search: filter.search,
      month: filter.month,
      area: filter.area,
      cluster: filter.cluster,
      officer: filter.officer,
      activity: filter.activity
    }
  })
}

const getTableOptions = async () => {
  return await fTable.getItem(storageKey)
}

export {
  setTableOptions,
  getTableOptions
}
